if (!window.Promise) {
  window.Promise = require('es6-promise').Promise
}
